import React, { useEffect, useState } from "react";
import Pagination from '../../../../components/Pagination';
import Loader from '../../../../components/Loader';
import Table from "./Table";
import api from "../../../../auth/api";

export default function GiftCardCancelled() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemPerPage = 10;

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      const response = await api.get(`/redeem/panel/gift/card/request/cancelled?page=${currentPage}`);
      setData(response?.data?.result);
      let pageCount = Math.ceil(response?.data?.pagination?.count / itemPerPage);
      setTotalPages(pageCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const headers = data?.length > 0 ? Object?.keys(data[0]).filter(key => key !== 'id') : [];

  if (loading) return <Loader />;

  return (
    <div className="w-full flex items-center flex-col">
      <Table
        headers={headers}
        rows={data}
      />

      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
      </div>
    </div>
  );
}